import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { uploadFile } from '../../utils';
import { BASE_URL, getToken } from '../asyncConfig';

export const getUsers = createAsyncThunk(
  'users/getAllUsers', async (criterial, {rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/retrieve/accounts/${criterial}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );      
      return fulfillWithValue(data.accounts);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getUsersFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.users = action.payload;
  state.message = '';
}

export const getUserById = createAsyncThunk(
  'users/getUser', async (id, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.get(
        `${BASE_URL}/admin/retrieve/user/${id}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );      
      return fulfillWithValue(data.account);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const verifyUserById = createAsyncThunk(
  'users/verify', async (id, {fulfillWithValue, rejectWithValue}) => {
    console.log('token', getToken());
    try {
      const {data} = await axios.patch(
        `${BASE_URL}/admin/account/verify/${id}`, {},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updateAccountStatusById = createAsyncThunk(
  'users/update', async ({id, is_active}, {fulfillWithValue, rejectWithValue}) => {
    try {
      const {data} = await axios.patch(
        `${BASE_URL}/admin/account/activeness/${id}`, 
        {is_active},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const creditRefund = createAsyncThunk(
  'users/credit-refund', async ({user_id, amount}, {fulfillWithValue, rejectWithValue}) => {
    try {
      const {data} = await axios.post(
        `${BASE_URL}/admin/credit-refund/${user_id}`, 
        {amount}, {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
); 

export const updateUserVerificationStatus = createAsyncThunk(
  'users/verification-status', async ({id, status, verification_comment}, {fulfillWithValue, rejectWithValue}) => {
    try {
      const {data} = await axios.patch(
        `${BASE_URL}/admin/user/verification/status/${id}`, 
        {status, verification_comment},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updateUserDetailsById = createAsyncThunk(
  'users/update', async ({
    id, basicInfo, accountSettingsInfo, driverOtherInfo}, {fulfillWithValue, rejectWithValue}) => {
    try {
      let profile_pic_url, driving_license_pic_url, id_card_img_url;
      if(driverOtherInfo.driving_license_pic && typeof driverOtherInfo.driving_license_pic !== 'string'){
        const res = await uploadFile(
          driverOtherInfo.driving_license_pic, 
          'driving_license_pic', 
          id
        );
        if(!res.success){
          return rejectWithValue(res.response.data);
        }
        const {metadata} = res;
        driving_license_pic_url = metadata.url;
      }
      if (basicInfo.profile_pic && typeof basicInfo.profile_pic !== 'string'){
        const res = await uploadFile(
          basicInfo.profile_pic, 
          'profile_pic', 
          id
        );
        if(!res.success){
          return rejectWithValue(res.response.data);
        }
        const {metadata} = res;
        profile_pic_url = metadata.url;
      }
      if (basicInfo.id_card_img && typeof basicInfo.id_card_img !== 'string'){
        const res = await uploadFile(
          basicInfo.id_card_img, 
          'id_card_img', 
          id
        );
        if(!res.success){
          return rejectWithValue(res.response.data);
        }
        const {metadata} = res;
        id_card_img_url = metadata.url;
      }
      const driving_license_pic = driving_license_pic_url || driverOtherInfo.driving_license_pic;
      const profile_pic = profile_pic_url || basicInfo.profile_pic;
      const id_card_img = id_card_img_url || basicInfo.id_card_img;
      const {data} = await axios.patch(
        `${BASE_URL}/admin/user/${id}`, {
          basicInfo: { ...basicInfo, profile_pic, id_card_img }, 
          accountSettingsInfo, 
          driverOtherInfo: {...driverOtherInfo, driving_license_pic}
        },
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)